import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment/moment';
import { CheckboxesTags, CreateChancel, DateTypeSelect, SelectAutocompletePaginationMultiple } from 'components';
import { Images, renderStaffName, staffStatusEnums, useModal } from 'utils';
import { CsvService } from 'store';
import { useNavigate, useLocation } from 'react-router-dom';

export const DownloadPayrollCsv = ({ status }) => {
    const staff = useSelector((state) => state.admins.adminsList);
    const [error, setError] = useState('');
    const [inputs, setInputs] = useState({});
    const [load, setLoad] = useState(false);
    const { close } = useModal();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;

    useEffect(() => {
        if (info) {
            const params = {
                startDate: info?.start,
                endDate: info?.end,
            };
            info?.staffFull?.length ? (params.staffs = info.staffFull) : delete params.staffs;
            setInputs(params);
        }
    }, [info]);

    const handleChangeStaffs = (e) => {
        setInputs((prevState) => ({ ...prevState, ['staffs']: e.target?.full }));
    };
    const handleChange = (e) => {
        setInputs((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
        error === e.target.name && setError('');
    };

    const handleExport = async () => {
        setLoad(true);
        let response = '';

        try {
            const params = {
                status: status,
                startDate: inputs?.startDate,
                endDate: inputs?.endDate,
            };

            inputs?.staffs?.length ? (params.staffs = inputs.staffs?.map((i) => i?.id)) : delete params.staffs;
            response = await CsvService.activePassivePayrollCsv(params);
            const type = status === 'ACTIVE' ? 'activePayroll' : 'processedPayroll';
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${type}.csv`);
            document.body.appendChild(link);
            link.click();
            setLoad(false);
            close();
        } catch (e) {
            setLoad(false);
            close();
        }
    };

    return (
        <div className="download-payroll-csv-modal">
            <p className="download-modal-title">Download Payroll CSV</p>
            <p className="download-modal-desc">
                Select the date range and staff for the payroll data you wish to download. The fields will be pre-filled based on your
                current filters.
            </p>
            <div className="download-modal-body">
                <SelectAutocompletePaginationMultiple
                    defaultStatuses={[staffStatusEnums.ACTIVE]}
                    title={'Staff'}
                    name={'staffs'}
                    placeholder={'Select Staff'}
                    handleSelect={handleChangeStaffs}
                    defaultValue={inputs?.staffs ? inputs.staffs : []}
                    renderValue={(i) => renderStaffName(i)}
                    type={'staff'}
                />
                <div className="start-end-time-box">
                    <DateTypeSelect
                        type={'modalInput'}
                        name={'startDate'}
                        outLabel={'Start Date'}
                        handleGetDates={handleChange}
                        values={inputs}
                        max={inputs.endDate ? moment.utc(inputs.endDate).format('YYYY-MM-DD') : ''}
                    />
                    <DateTypeSelect
                        type={'modalInput'}
                        name={'endDate'}
                        outLabel={'End Date'}
                        handleGetDates={handleChange}
                        values={inputs}
                        min={inputs.startDate ? moment.utc(inputs.startDate).format('YYYY-MM-DD') : ''}
                    />
                </div>
            </div>

            <div>
                <CreateChancel
                    image={Images.downloadCloudWhite}
                    loader={load}
                    create={'Download CSV'}
                    chancel={'Cancel'}
                    onCreate={handleExport}
                    onClose={() => close()}
                    buttonWidth="300px"
                />
            </div>
        </div>
    );
};
